import { useSelector } from 'react-redux';
import isCompanyAdminSelector from 'store/selectors/isCompanyAdmin';
import { useCompanyFeature } from 'utils/useCompanyFeature';
import { useCompanyFeaturesReady } from 'utils/useCompanyFeaturesReady';

/**
 * Fail-closed employee-management gate for team admins when integratedUsers is on.
 * Waits for /me before evaluating flags so stale persisted company data cannot
 * briefly expose create/edit/delete controls.
 */
export function useCanManageEmployees() {
  const featuresReady = useCompanyFeaturesReady();
  const integratedUsers = useCompanyFeature('integratedUsers');
  const isCompanyAdmin = useSelector(isCompanyAdminSelector);

  if (isCompanyAdmin) {
    return true;
  }
  if (!featuresReady) {
    return false;
  }
  return !integratedUsers;
}
